module.exports = __webpack_public_path__ + "static/wallace-selma-a6cd630e6cc153a51a224684dbc7a81c.jpg";